import React from 'react';
import getAppSite from 'utils/getAppSite';
let monitoringData = [
  {
    name: 'Political monitoring portal',
    free: 'yes',
    basic: 'yes',
    pro: 'yes',
    mogul: 'yes',
    custom: 'yes',
  },

  {
    name: 'Email alerts',
    free: 'yes',
    basic: 'yes',
    pro: 'yes',
    mogul: 'yes',
    custom: 'yes',
  },

  {
    name: 'Topics to monitor',
    agenciesName: 'Clients',
    free: '1',
    basic: '1',
    pro: () => (
      <>
        3
        <span
          className='pricing-feature-more'
          data-tooltip-html={
            'The Pro plan includes three<br/> topics, and additional<br/> topics can be purchased<br/> (see above for pricing).'
          }
          data-tooltip-id={'pricing-page-tooltip'}
        >
          More information
        </span>{' '}
      </>
    ),
    mogul: () => (
      <>
        5
        <span
          className='pricing-feature-more'
          data-tooltip-html={
            'The Mogul plan includes five<br/> topics, and additional<br/> topics can be purchased<br/> (see above for pricing).'
          }
          data-tooltip-id={'pricing-page-tooltip'}
          data-tooltip-class-name='header-tooltip pricing-feature-tooltip'
        >
          More information
        </span>{' '}
      </>
    ),
    mogulAgencies: 'unlimited',
    custom: 'unlimited',
    hoverText: `Topics comprise keywords<br/> and phrases related to your<br/> ${
      getAppSite() === 'usa' ? 'organization' : 'organisation'
    } or interests`,
    agenciesHoverText: 'hide',
  },
  {
    name: 'Keywords per topic',
    free: 'up to 5',
    basic: 'unlimited',
    pro: 'unlimited',
    mogul: 'unlimited',
    custom: 'unlimited',
    hideForAgencies: true,
  },

  {
    name: 'AI assistant',
    basic: 'yes',
    pro: 'yes',
    mogul: 'yes',
    mogulAgencies: 'yes',
    custom: 'yes',
    customAgencies: 'yes',
    hoverText: `PolicyMogul’s AI assistant is available across all updates.<br/> It uses the content of the update alongside your ${
      getAppSite() === 'usa' ? 'organization' : 'organisation'
    }<br/> description, allowing you to ask questions and get tailored answers`,
  },

  {
    name: 'AI summaries',
    hoverText: `Political developments can be summarised using AI<br/> in one click, showing tailored information about why<br/> the update is relevant to your ${
      getAppSite() === 'usa' ? 'organization' : 'organisation'
    } and work`,
    pro: 'yes',
    mogul: 'yes',
    custom: 'yes',
  },

  {
    name: 'AI credits',
    basic: '10 / month',
    pro: '25 / month',
    mogul: '100 / month',
    mogulAgencies: '75 / month',
    custom: 'unlimited',
    customAgencies: 'unlimited',
    hoverText: `AI credits can be used to generate tailored summaries<br/> of updates and to start conversations with the AI assistant.<br/> Each conversation costs 1 credit`,
  },

  {
    name: 'Advanced keyword logic',
    pro: 'yes',
    mogul: 'yes',
    custom: 'yes',
    hoverText:
      'Use Boolean logic to home in on<br/> the results that matter to you,<br/> and avoid information overload',
  },
  {
    name: 'Parliament live',
    mogul: 'yes',
    custom: 'yes',
    hoverText:
      'Parliament live gives you real-time<br/>  transcription and alerts from the Commons,<br/> Lords, Westminster Hall and committees',
  },

  {
    name: 'Integration with Slack',
    mogul: 'yes',
    custom: 'yes',
    hoverText: 'Set up immediate alerts via Slack for any topic',
  },

  {
    name: 'Policymakers on X ',
    basic: 'Add-on',
    pro: 'Add-on',
    mogul: 'Add-on',
    custom: 'yes',
    hoverText: `PolicyMogul monitors X posts and<br/> reposts from key political stakeholders`,
  },

  {
    name: 'Early access to news',
    custom: 'yes',
    hoverText:
      'News is shared in advance of publication when<br/> permitted and is conditional on adherence to<br/> distribution requirements. For details on early<br/> access conditions, please contact our team',
  },
];

if (import.meta.env.VITE_APP_ENABLE_TWITTER === 'false') {
  let tweetsPosition = monitoringData.findIndex((item) => item.name === 'Policymakers on X');
  monitoringData.splice(tweetsPosition, 1);
}

let emailAlertsData = [
  {
    name: 'Daily & weekly email digest',
    basic: 'yes',
    pro: 'yes',
    mogul: 'yes',
    custom: 'yes',
  },

  {
    name: 'Immediate email alerts',
    pro: 'yes',
    mogul: 'yes',
    custom: 'yes',
  },
];

let influenceData = [
  {
    name: 'Policymaker CRM',
    basic: 'yes',
    pro: 'yes',
    mogul: 'yes',
    custom: 'yes',
    hoverText: `Manage stakeholders including sending tracked<br/> emails, writing notes, adding tags, exporting data,<br/> and taking other actions`,
  },
  {
    name: 'Stakeholder mapping',
    basic: 'yes',
    pro: 'yes',
    mogul: 'yes',
    custom: 'yes',
    hoverText: `Identify the ${
      getAppSite() === 'usa' ? 'policymakers' : 'parliamentarians'
    }<br/> interested in your issues`,
    agenciesHoverText: 'Identify the most relevant and influential<br/> political stakeholders for each client',
  },
  {
    name: 'Groups',
    basic: '3',
    pro: '5',
    mogul: '8',
    custom: 'unlimited',
    hoverText: `Refers to the total number of stakeholder<br/> groups you can have at any one time`,
  },
  {
    name: 'Dynamic groups',
    mogul: 'yes',
    custom: 'yes',
    hoverText: `Dynamic groups automatically update based on<br/> the criteria you set, adding or removing stakeholders<br/> as they meet those conditions`,
  },
  {
    name: 'Email campaigns',
    basic: '3  / month',
    pro: '10  / month',
    mogul: 'unlimited',
    custom: 'unlimited',
    hoverText: `Send emails from your own email<br/> address to policymakers and other <br/> stakeholders with open and click tracking`,
  },
  /* {
    name: 'Contacts',
    basic: '50',
    pro: '650',
    mogul: '1,500',
    mogulAgencies: '50',
    custom: 'unlimited',
    customAgencies: '50',
    //customDropdown: true,
    hoverText: `The CRM includes contacts who <br/>can be added to your team's contact list so<br/> that you can email them, write notes,<br/> tag them, export them and take other actions.<br/> Additional contacts can be purchased for £19<br/>per month per 50 contacts`,
  }, */
];

let reportsData = [
  {
    name: 'Create reports',
    mogul: 'yes',
    custom: 'yes',
    hoverText: 'Create customised reports on any issue<br/> using political data, analytics and more',
  },

  {
    name: 'Remove branding',
    custom: 'yes',
    customAgencies: 'no',
    hoverText: `The text 'Powered by PolicyMogul' will<br/> appear at the bottom of reports you create.<br/> On the Enterprise plan, you have the option<br/> to remove this text`,
  },
];

let researchData = [
  {
    name: 'Historic content',
    basic: 'yes',
    pro: 'yes',
    mogul: 'yes',
    custom: 'yes',
    hoverText:
      'Use advanced filters and keyword<br/> rules to identify historic political<br/> updates related to any issue',
  },
  {
    name: 'Advanced search',
    pro: 'yes',
    mogul: 'yes',
    custom: 'yes',
    hoverText: 'Home in on the results<br/> that matter to you, and avoid<br/> information overload',
  },
  /*AE:Left for now, just in case it's needed in the future
  {
    name: 'Insights',
    custom: 'yes',
    hoverText: 'Drill into the specific contributions<br/> which make up any data set',
  }, */
  {
    name: 'Research team',
    custom: 'yes',
    hoverText: 'Our team of parliamentary <br/>experts is on hand to help <br/>with your political research',
  },
];

let embeddablesData = [
  {
    name: 'Embed news feeds',
    pro: () => (
      <>
        limited
        <span
          className='pricing-feature-more'
          data-tooltip-html={
            'Updates clicked by your website visitors will open the<br/> content in a separate tab in PolicyMogul.'
          }
          data-tooltip-id={'pricing-page-tooltip'}
        >
          More information
        </span>{' '}
      </>
    ),
    mogul: 'yes',
    custom: 'yes',
    hoverText:
      'Embed a feed of political developments directly on your website, featuring real-time updates related to any issue',
    tooltipClass: 'header-tooltip report-popup-tooltip',
  },
  {
    name: 'Embed political data',
    pro: 'yes',
    mogul: 'yes',
    custom: 'yes',
    hoverText:
      'Embed specific charts, or a full analytics dashboard directly on your website, featuring real-time political data related to any issue',
    tooltipClass: 'header-tooltip report-popup-tooltip',
  },
  {
    name: 'Remove branding',
    custom: 'yes',
    hoverText: `The text 'Powered by PolicyMogul' will appear at the bottom of feeds and charts you embed. On the Enterprise plan, you have the option to remove this text`,
    tooltipClass: 'header-tooltip report-popup-tooltip',
  },
];

let supportData = [
  {
    name: 'Customer support',
    basic: 'email & chat',
    pro: 'email, chat & phone',
    mogul: 'email, chat & phone',
    custom: 'email, chat & phone',
  },

  {
    name: 'Dedicated account manager',
    mogul: 'yes',
    custom: 'yes',
  },
];

let PricingData = [
  {
    name: 'Customer support',
    basic: 'email',
    pro: 'email',
    mogul: 'phone',
    custom: 'phone',
  },

  {
    name: 'Dedicated account manager',
    mogul: 'yes',
    custom: 'yes',
  },
];

let analyticsData = [
  {
    name: 'Analytics',
    pro: 'yes',
    mogul: 'yes',
    mogulAgencies: 'no include',
    custom: 'yes',
    hoverText:
      'Our analytics platform provides real-time data from across the political landscape in relation to any issue. It includes dashboards and charts showing trends, such as the number of parliamentary contributions, sentiment amongst policymakers, interest by region, and more.',
    tooltipClass: 'header-tooltip report-popup-tooltip',
  },
  {
    name: 'Sentiment analysis',
    mogul: 'yes',
    mogulAgencies: 'no include',
    custom: 'yes',
    hoverText:
      'Identify whether policymakers are speaking positively<br/> or negatively in relation to any issue, and dig into the data<br/> by person, party, region, position, contribution type and more',
  },
];

let briefPolicymakersData = [
  {
    name: 'Present lobbying material',
    free: 'yes',
    basic: 'yes',
    pro: 'yes',
    mogul: 'yes',
    custom: 'yes',
    hoverText:
      'Make research, news releases and other<br/> briefing material available to relevant political<br/> stakeholders and other organisations',
    hideForAgencies: true,
  },
  {
    name: 'Restrict audience',
    custom: 'yes',
    hoverText: `Choose whether your lobbying material<br/> is visible to everyone or only to policymakers`,
  },
];

export {
  monitoringData,
  emailAlertsData,
  supportData,
  PricingData,
  influenceData,
  researchData,
  reportsData,
  embeddablesData,
  analyticsData,
  briefPolicymakersData,
};
